<template>
  <dashboard :uppy="uppyConfig" :props="dashboardProps"></dashboard>
</template>

<script>
import { Dashboard } from '@uppy/vue'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'

export default {
  name: 'ImportModal',
  components: {
    Dashboard,
  },
  props: {
    uppyConfig: {},
  },
  data: () => ({
    dashboardProps: {
      inline: true,
      locale: 'pt_BR',
      height: 470,
      width: '100%',
      proudlyDisplayPoweredByUppy: false,
    },
  }),
}
</script>

<style>
button[aria-controls='uppy-DashboardContent-panel--Vimeo'] > svg {
  visibility: hidden !important;
}

button[aria-controls='uppy-DashboardContent-panel--Vimeo']::before {
  content: url('../assets/vimeoIcon.png');
}

.uppy-DashboardContent-panelBody .uppy-Url .uppy-c-textInput {
  width: 380px !important;
}

.uppy-DashboardContent-panelBody .uppy-Url .uppy-c-btn {
  margin: 10px auto 0;
  display: table;
}

.uppy-Dashboard-Item-previewInnerWrap {
  pointer-events: none;
}
</style>
